import { render, staticRenderFns } from "./ReclamoNoValido.vue?vue&type=template&id=0452ad31&scoped=true"
import script from "./ReclamoNoValido.vue?vue&type=script&lang=js"
export * from "./ReclamoNoValido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452ad31",
  null
  
)

export default component.exports